import {withAuth} from '../WithAuth'
import {
    CAN_ADMINISTER_USER,
    CAN_DELETE_JOB,
    CAN_EDIT_COLOR_RECIPE,
    CAN_EDIT_ESTIMATE,
    CAN_EDIT_FOREMAN_BOULDER_WORK_ORDER,
    CAN_EDIT_FOREMAN_GUNITE_WORK_ORDER,
    CAN_EDIT_FOREMAN_PEBBLE_DAILY_WORK_ORDER,
    CAN_EDIT_FOREMAN_PEBBLE_WORK_ORDER,
    CAN_EDIT_FOREMAN_PREP_WORK_ORDER,
    CAN_EDIT_GUNITE_JOB_ALL,
    CAN_EDIT_GUNITE_JOB_ASSIGNED_TO_USER,
    CAN_EDIT_GUNITE_SCHEDULE,
    CAN_EDIT_INVENTORY,
    CAN_EDIT_MOBILE_PRESITE,
    CAN_EDIT_PLASTER_JOBS_ALL,
    CAN_EDIT_PLASTER_JOBS_ASSIGNED_TO_USER,
    CAN_EDIT_PLASTER_SCHEDULE,
    CAN_EDIT_ROLES,
    CAN_EDIT_WARRANTY_JOBS,
    CAN_EXPORT_DATA,
    CAN_MOBILE_UPLOAD,
    CAN_REORDER_PEBBLE_CREWS,
    CAN_REORDER_WARRANTY_CREW,
    CAN_SCHEDULE_PRESITE,
    CAN_SEND_BUILDER_EMAIL,
    CAN_SUPERVISE_OTHERS,
    CAN_VIEW_ADMIN_DASHBOARD,
    CAN_VIEW_COLOR_RECIPE,
    CAN_VIEW_ESTIMATE,
    CAN_VIEW_GUNITE_JOB_ALL,
    CAN_VIEW_GUNITE_JOB_ASSIGNED_TO_USER,
    CAN_VIEW_GUNITE_SCHEDULE,
    CAN_VIEW_INVENTORY,
    CAN_VIEW_JOB,
    CAN_VIEW_MOBILE_DASHBOARD,
    CAN_VIEW_MOBILE_MAP,
    CAN_VIEW_MOBILE_SEARCH,
    CAN_VIEW_MOBILE_WORK_ORDERS,
    CAN_VIEW_MY_JOBS,
    CAN_VIEW_PLASTER_JOBS_ALL,
    CAN_VIEW_PLASTER_JOBS_ASSIGNED_TO_USER,
    CAN_VIEW_PLASTER_SCHEDULE,
    CAN_VIEW_PRINT_QUEUE,
    CAN_VIEW_REPORT_CALENDAR_GUNITE,
    CAN_VIEW_REPORT_CALENDAR_PEBBLE,
    CAN_VIEW_REPORT_COVERAGE,
    CAN_VIEW_REPORT_CUSTOMER_CONTACT_LIST,
    CAN_VIEW_REPORT_CUSTOMER_TOP_50_CONTACTS,
    CAN_VIEW_REPORT_INVENTORY,
    CAN_VIEW_REPORT_PER_COMPANY_JOB,
    CAN_VIEW_REPORT_SLURRY_PICKUP,
    CAN_VIEW_REPORT_YEAR_OVER_YEAR_GUNITE,
    CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE,
    CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE_REMODEL,
    CAN_VIEW_REPORTS,
    CAN_VIEW_ROLES,
    CAN_VIEW_WARRANTY_JOBS,
    CAN_REORDER_GUNITE_CREW,
    CAN_REORDER_BOULDER_CREW,
    CAN_VIEW_JOB_MENU,
    CAN_VIEW_MAP_SEARCH_MENU,
    CAN_VIEW_INVENTORY_MENU,
    CAN_VIEW_REPORTS_MENU,
    CAN_VIEW_SCHEDULE_MENU,
    CAN_MOVE_ALL_SCHEDULE_BOARD_CARDS,
} from '../../utils/enums'

export const CanViewJob = withAuth(CAN_VIEW_JOB)
export const CanAdministerUsers = withAuth(CAN_ADMINISTER_USER)
export const CanViewReports = withAuth(CAN_VIEW_REPORTS)
export const CanViewInventory = withAuth(CAN_VIEW_INVENTORY)
export const CanEditInventory = withAuth(CAN_EDIT_INVENTORY)
export const CanViewAdminDashboard = withAuth(CAN_VIEW_ADMIN_DASHBOARD)
export const CanReorderWarrantyCrew = withAuth(CAN_REORDER_WARRANTY_CREW)
export const CanReorderPebbleCrews = withAuth(CAN_REORDER_PEBBLE_CREWS)
export const CanReorderGuniteCrew = withAuth(CAN_REORDER_GUNITE_CREW)
export const CanReorderBoulderCrew = withAuth(CAN_REORDER_BOULDER_CREW)
export const CanViewRoles = withAuth(CAN_VIEW_ROLES)
export const CanEditRoles = withAuth(CAN_EDIT_ROLES)
export const CanViewEstimate = withAuth(CAN_VIEW_ESTIMATE)
export const CanEditEstimate = withAuth(CAN_EDIT_ESTIMATE)
export const CanViewGuniteSchedule = withAuth(CAN_VIEW_GUNITE_SCHEDULE)
export const CanEditGuniteSchedule = withAuth(CAN_EDIT_GUNITE_SCHEDULE)
export const CanViewGuniteJobAll = withAuth(CAN_VIEW_GUNITE_JOB_ALL)
export const CanEditGuniteJobAll = withAuth(CAN_EDIT_GUNITE_JOB_ALL)
export const CanViewGuniteJobAssignedToUser = withAuth(CAN_VIEW_GUNITE_JOB_ASSIGNED_TO_USER)
export const CanEditGuniteJobAssignedToUser = withAuth(CAN_EDIT_GUNITE_JOB_ASSIGNED_TO_USER)
export const CanViewPlasterSchedule = withAuth(CAN_VIEW_PLASTER_SCHEDULE)
export const CanEditPlasterSchedule = withAuth(CAN_EDIT_PLASTER_SCHEDULE)
export const CanViewPlasterJobsAll = withAuth(CAN_VIEW_PLASTER_JOBS_ALL)
export const CanEditPlasterJobsAll = withAuth(CAN_EDIT_PLASTER_JOBS_ALL)
export const CanViewPlasterJobsAssignedToUser = withAuth(CAN_VIEW_PLASTER_JOBS_ASSIGNED_TO_USER)
export const CanEditPlasterJobsAssignedToUser = withAuth(CAN_EDIT_PLASTER_JOBS_ASSIGNED_TO_USER)
export const CanViewWarrantyJobs = withAuth(CAN_VIEW_WARRANTY_JOBS)
export const CanEditWarrantyJobs = withAuth(CAN_EDIT_WARRANTY_JOBS)
export const CanViewReportCalendarGunite = withAuth(CAN_VIEW_REPORT_CALENDAR_GUNITE)
export const CanViewReportCalendarPebble = withAuth(CAN_VIEW_REPORT_CALENDAR_PEBBLE)
export const CanViewReportCustomerContactList = withAuth(CAN_VIEW_REPORT_CUSTOMER_CONTACT_LIST)
export const CanViewReportCustomerTop50Contacts = withAuth(CAN_VIEW_REPORT_CUSTOMER_TOP_50_CONTACTS)
export const CanViewReportCoverage = withAuth(CAN_VIEW_REPORT_COVERAGE)
export const CanViewReportPerCompanyJob = withAuth(CAN_VIEW_REPORT_PER_COMPANY_JOB)
export const CanViewReportSlurryPickup = withAuth(CAN_VIEW_REPORT_SLURRY_PICKUP)
export const CanViewReportYearOverYearGunite = withAuth(CAN_VIEW_REPORT_YEAR_OVER_YEAR_GUNITE)
export const CanViewReportYearOverYearPebble = withAuth(CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE)
export const CanViewReportYearOverYearPebbleRemodel = withAuth(CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE_REMODEL)
export const CanViewReportInventory = withAuth(CAN_VIEW_REPORT_INVENTORY)
export const CanViewColorRecipe = withAuth(CAN_VIEW_COLOR_RECIPE)
export const CanEditColorRecipe = withAuth(CAN_EDIT_COLOR_RECIPE)
export const CanDeleteJob = withAuth(CAN_DELETE_JOB)

export const CanExportData = withAuth(CAN_EXPORT_DATA)
export const CanSchedulePresite = withAuth(CAN_SCHEDULE_PRESITE)
export const CanViewMobileDashboard = withAuth(CAN_VIEW_MOBILE_DASHBOARD)
export const CanViewMobileSearch = withAuth(CAN_VIEW_MOBILE_SEARCH)
export const CanSuperviseOthers = withAuth(CAN_SUPERVISE_OTHERS)
export const CanMobileUpload = withAuth(CAN_MOBILE_UPLOAD)
export const CanViewMobileMap = withAuth(CAN_VIEW_MOBILE_MAP)
export const CanViewMobileWorkOrders = withAuth(CAN_VIEW_MOBILE_WORK_ORDERS)
export const CanEditMobilePresite = withAuth(CAN_EDIT_MOBILE_PRESITE)

export const CanViewMyJobs = withAuth(CAN_VIEW_MY_JOBS)
export const CanEditForemanBoulderWorkOrder = withAuth(CAN_EDIT_FOREMAN_BOULDER_WORK_ORDER)
export const CanEditForemanGuniteWorkOrder = withAuth(CAN_EDIT_FOREMAN_GUNITE_WORK_ORDER)
export const CanEditForemanPebbleDailyWorkOrder = withAuth(CAN_EDIT_FOREMAN_PEBBLE_DAILY_WORK_ORDER)
export const CanEditForemanPebbleWorkOrder = withAuth(CAN_EDIT_FOREMAN_PEBBLE_WORK_ORDER)
export const CanEditForemanPrepWorkOrder = withAuth(CAN_EDIT_FOREMAN_PREP_WORK_ORDER)
export const CanSendBuilderEmail = withAuth(CAN_SEND_BUILDER_EMAIL)
export const CanViewPrintQueue = withAuth(CAN_VIEW_PRINT_QUEUE)

export const CanViewJobMenu = withAuth(CAN_VIEW_JOB_MENU)
export const CanViewMapSearchMenu = withAuth(CAN_VIEW_MAP_SEARCH_MENU)
export const CanViewInventoryMenu = withAuth(CAN_VIEW_INVENTORY_MENU)
export const CanViewReportsMenu = withAuth(CAN_VIEW_REPORTS_MENU)
export const CanViewScheduleMenu = withAuth(CAN_VIEW_SCHEDULE_MENU)

export const CanMoveAllScheduleBoardCards = withAuth(CAN_MOVE_ALL_SCHEDULE_BOARD_CARDS)